import { useDispatch } from "react-redux";
import { logOut } from "../../redux/reducers/user.reducer";
import { useLocalStorage } from "./useLocalStorage";
import { useNavigate } from "react-router";
import ROUTE_CONSTANT from "../../routes/routeconstants";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [, setValue] = useLocalStorage("token", null);
  const userLogout = () => {
    dispatch(logOut());
    setValue(null);
    navigate(ROUTE_CONSTANT.LOGIN);
  };
  return {
    userLogout,
  };
};

export default useLogout;
